<template>
  <div>
    <wv-cell-swipe title="是否绑定" :value="wechatstate"> </wv-cell-swipe>
   
    <div class="weui-cell">
      <wv-button type="primary"   @click="btnSave()">解绑</wv-button>
      </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import { Dialog } from 'we-vue'
export default {
    name: "setlock",
    data: function() {
        return {
            openID: ""
        };
    },
    created: function() {
        this.InitOpenID();
    },
    computed: {
        wechatstate:function(){
            return this.openID==''?'否':'是';
        }
    },
    methods: {
        InitOpenID: function() {
            this.$http
                .get(this.GLOBAL.BASE_URL + "api/login/initopenid", {})
                .then(
                    function(d) {
                        var rep = JSON.parse(d.bodyText);
                        if (rep.Success) {
                            this.openID = rep.Data;
                        } else {
                            Toast.fail(rep.Message);
                        }
                    },
                    function(d) {
                        console.log(d);
                    }
                );
        },
        btnSave: function() {
            Dialog.confirm({
                title: "",
                message: "确认解绑微信？",
                skin: 'ios',
                showCancelButton: true
            })
                .then(() => {
                    this.$http
                        .post(
                            this.GLOBAL.BASE_URL + "api/login/openidremove",
                            {},
                            { emulateJSON: true }
                        )
                        .then(
                            function(d) {
                                var rep = JSON.parse(d.bodyText);
                                if (rep.Success) {
                                    Toast.success("保存成功");
                                    this.$router.push("/app/us");
                                } else {
                                    Toast.fail(rep.Message);
                                }
                            },
                            function(d) {
                                console.log(d);
                            }
                        );
                })
                .catch(() => {

                });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/set/setlock.vue